// Les droits et la qualification viennent du serveur ; la sélection reste
// limitée aux résultats visibles de la découverte courante.
// Carrousel « À la une » : sorties des organisateurs certifiés (ADR-019), toujours
// et en premier, puis celles des nouveaux organisateurs.
function isApprovedOrganizerEvent(event) {
  return event.organizer?.isApprovedOrganizer === true;
}

function resolveStartTime(event) {
  return new Date(event.startsAt || `${event.date}T${event.startTime || "00:00"}:00`).getTime();
}

export function selectNewOrganizerEvents(events, now = Date.now()) {
  const sorted = events.filter((event) => {
    return (event.isNewOrganizer === true || isApprovedOrganizerEvent(event)) && event.organizerId &&
      event.status === "published" && event.visibility === "public" &&
      event.relationshipAudience === "all" && resolveStartTime(event) > now &&
      Number.isFinite(event.location?.lat) && Number.isFinite(event.location?.lng);
  }).sort((a, b) => Number(isApprovedOrganizerEvent(b)) - Number(isApprovedOrganizerEvent(a)) ||
    resolveStartTime(a) - resolveStartTime(b) || String(a.id).localeCompare(String(b.id)));
  const organizers = new Set();
  return sorted.filter((event) => {
    if (organizers.has(event.organizerId)) return false;
    organizers.add(event.organizerId);
    return true;
  }).slice(0, 16);
}
